import {load} from '@shopify/theme-sections';

import '../sections/testimonials';
import '../sections/featured-collection-slider';
import '../sections/swatch';

import Testimonial from '../sections/testimonials-two';
import katiesStory from '../sections/katies-story';
import MustHaves from '../sections/must-haves-collection';
import BestSellers from '../sections/best-sellers-collection';
import Readmore from '../sections/product-readmore';

if (document.body.classList.contains('template-index')) {
  load('*');

  Testimonial().init();
  MustHaves().init();
  BestSellers().init();

  Readmore().init();
  katiesStory().init();
}
